/**
 * Environment Configuration
 * 
 * This file provides centralized access to all configuration values.
 * It checks window.APP_CONFIG first (for production builds with runtime config),
 * then falls back to process.env (for development).
 * 
 * Usage:
 *   import { Config } from 'config/envConfig';
 *   const host = Config.NODE_SERVER_HOST;
 *   
 *   // Or use getEnv for dynamic access (backward compatible)
 *   import { getEnv } from 'config/envConfig';
 *   const host = getEnv('REACT_APP_NODE_SERVER_HOST');
 */

// Helper to get config value from window.APP_CONFIG or process.env
const getEnvValue = (key, defaultValue = '') => {
  if (typeof window !== 'undefined' && window.APP_CONFIG && window.APP_CONFIG[key] !== undefined) {
    return window.APP_CONFIG[key];
  }
  return process.env[key] ?? defaultValue;
};

// =============================================================================
// CENTRALIZED CONFIG OBJECT
// =============================================================================
export const Config = {
  // ==================== Server Addresses ====================
  HOST: getEnvValue('PRODUCT_SUPPORT_HOST', 'localhost'),
  PORT: getEnvValue('PORT', '3002'),
  NODE_SERVER_HOST: getEnvValue('REACT_SERVER_HOST', 'localhost'),
  NODE_SERVER_PORT: getEnvValue('NODE_SERVER_PORT', '443/nodejs'),
  FAST_API_HOST: getEnvValue('REACT_SERVER_HOST', 'localhost'),
  FAST_API_PORT: getEnvValue('FAST_API_PORT', '443/fastapi'),
  SOCKET_MANAGER_HOST: getEnvValue('REACT_SERVER_HOST', 'localhost'),
  SOCKET_MANAGER_PORT: getEnvValue('SOCKET_MANAGER_PORT','443'),

  // ==================== Security ====================
  USE_SECURED_CONNECTION: getEnvValue('REACT_APP_USE_SECURED_CONNECTION', 'true'),
  CAPTCHA_SITE_KEY: getEnvValue('REACT_APP_CAPTCHA_SITE_KEY', "6LdZM08qAAAAAHxlNdyySbRmZ0Bn65LKXVNNkZxD"),


  // ==================== File Constraints ====================
  MAX_TOTAL_ATTACHMENT_COUNT: '5',
  MAX_ATTACHMENT_PAGE_COUNT: '5',
  TEXT_FILE_MAX_CHARS: '24000',

  // ==================== Computed URLs ====================
  get IS_HTTPS() {
    return this.USE_SECURED_CONNECTION === 'true';
  },
  get PROTOCOL() {
    return this.IS_HTTPS ? 'https' : 'http';
  },
  get WS_PROTOCOL() {
    return this.IS_HTTPS ? 'wss' : 'ws';
  },
};

// =============================================================================
// BACKWARD COMPATIBLE getEnv FUNCTION
// =============================================================================
export const getEnv = (key) => {
  return getEnvValue(key);
};

export default Config;
